exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".result {\r\n    margin-top: 30px;\r\n    border: 1px solid rgba(125,125,125,0.6);\r\n    display: inline-block;\r\n    padding: 1px;\r\n}\r\n\r\n.result.rounded > img {\r\n    border-radius: 100px;\r\n}\r\n\r\n.pull-left {\r\n    min-width: 400px;\r\n    float: left;\r\n    margin-right: 10px;\r\n    padding: 10px;\r\n    background-color: rgba(0,0,0,0.05);\r\n}\r\n\r\n@media only screen and (max-width: 1024px) {\r\n    .top-header-author{\r\n        position: absolute;\r\n    }\r\n }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/photo-upload/photo-upload.component.css
// module id = ../../../../../src/app/profile-update/photo-upload/photo-upload.component.css
// module chunks = main